import React, { useState, useEffect } from "react";
import { Feed } from "semantic-ui-react";
import { Link } from "react-router-dom";
import moment from "moment";

const RecentPost = ({ post, index }) => {
  const [postUser, setPostUser] = useState(null);
  const categoryColors = {
    "Market Today": "#2185d0", // blue
    "Market Insight": "#f2711c", // orange
    "Market Knowledge": "#21ba45", // green
  };
  useEffect(() => {
    const fetchUser = async (userId) => {
      try {
        const response = await fetch(`/api/user/${userId}`);
        const userData = await response.json();
        setPostUser(userData);
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    };

    if (post.userId) {
      fetchUser(post.userId);
    }
  }, [post.userId]);

  return (
    <Feed.Event style={{ paddingBottom: "12px" }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
        <div
          style={{
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            backgroundColor: "#2185d0",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            fontSize: "14px",
            flexShrink: 0,
            marginTop: "4px",
          }}
        >
          {index}
        </div>

        <div style={{ flex: 1 }}>
          <Feed.Content>
            <Feed.Summary style={{ fontSize: "1rem", fontWeight: 600 }}>
              <Link to={`/p/${post._id}`} className="post-title-link">
                {post.topic}
              </Link>
            </Feed.Summary>
            <Feed.Date
              style={{ fontSize: "12px", color: "#e7eef8", marginTop: "4px" }}
            >
              {moment(post.createdAt).format("MMM, D YY h:mm A")} (
              {moment(post.createdAt).startOf("minutes").fromNow()}) -{" "}
              <span style={{ color: categoryColors[post.category] || "gray" }}>
                {post.category}
              </span>
            </Feed.Date>
          </Feed.Content>
        </div>
      </div>
    </Feed.Event>
  );
};

export default RecentPost;
